export function formatMoney(amount, currency) {
  const rounded = Math.round(Number(amount) || 0);
  const n = rounded.toLocaleString("en-US");
  return currency === "USD" ? "$" + n : "K" + n;
}

export function currencySymbol(currency) {
  return currency === "USD" ? "$" : "K";
}

export function timeAgo(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (isNaN(then)) return "";
  const s = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  const w = Math.floor(d / 7);
  if (w < 5) return `${w}w ago`;
  const mo = Math.floor(d / 30);
  if (mo < 12) return `${mo}mo ago`;
  return `${Math.floor(d / 365)}y ago`;
}

export function clockTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  let h = d.getHours();
  const m = d.getMinutes().toString().padStart(2, "0");
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${m} ${ampm}`;
}

export function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();
}

export function offerEventLine(h, currency) {
  const amt = h?.amount != null ? formatMoney(h.amount, currency) : "";
  const who = h?.by === "seller" ? "Seller" : h?.by === "system" ? "System" : "Buyer";
  if (h?.type === "offer") return `${who} offered ${amt}`;
  if (h?.type === "counter") return `${who} countered ${amt}`;
  if (h?.type === "accepted") return `${who} accepted ${amt}`;
  if (h?.type === "declined") return `${who} declined`;
  if (h?.type === "expired") return "Offer expired";
  return `${who} ${h?.type ?? ""}`;
}
